import store from '../store'
import vm from '../main'

import { RESPONSE_MESSAGES } from '../config'

const internals = {}

internals.responseError = function (error) {
    let response = error.response
    if (
        response.status === 401

    ) {
        localStorage.clear()
        sessionStorage.clear()
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var spcook = cookies[i].split("=");
            document.cookie = spcook[0] + "=;expires=Thu, 21 Sep 1979 00:00:01 UTC;";
        }

        window.location.href = '/login'

        // If the token was invalid or the Refresh Token was expired, force user to login
    } else if (response.status === 403) {
        // The user is unauthorized
        console.debug('authInterceptor.service: 403: response:', response)

        // vm.$snotify.warning('Not authorized: ' + response.data.message, 'Warning')
    }
    // If not a 401 or 403, do nothing with this error. This is necessary to make a `responseError`
    // interceptor a no-op. */
    return Promise.reject(response)
}

export default {
    responseError: internals.responseError
}


// WEBPACK FOOTER //
// ./src/services/auth-interceptor.service.js